import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Table, Button, Row, Input, Divider, Popconfirm, message, Tag, Drawer } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import UnlabelledSources from './unlabelled_sources';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';

const queryString = require('query-string');

const source_cols=({onEditPressed,onDeletePressed})=>[
  {title:"ID",dataIndex:'id',key:'_id'},
  {
    title:"Name",
    dataIndex:'name',
    key:'name',

  },
  {
    title:"Description",
    dataIndex:'description',
    key:'description',

  },
  {title:"Labels",width:300,dataIndex:'source_labels',key:'source_labels',render:(labels=[])=><span>
    {labels.map((item,index)=><Tag key={index} style={{margin:2}}>{item}</Tag>)}
  </span>},
  {
    title:"",
    dataIndex:'id',
    key:'id',
    width:40,
    render:(id,data)=>{
      return <span>
        <Button type='link' onClick={()=>{
          typeof onEditPressed==='function'&&onEditPressed(data)
        }}>Edit</Button>
        {/* <Divider type='vertical'/>
        <Popconfirm title="Are you sure you want to delete this source?" onConfirm={()=>{
          typeof onDeletePressed==='function'&&onDeletePressed(data)
        }}>
        <Button type='link' style={{color:'red'}}>Delete</Button>
        </Popconfirm> */}
      </span>
    }
  }

]

const source_schema=[
  {name:"Source ID",index:'id',type:'text',show_update:false},
  {name:"Source Name",index:'name',type:'text'},
  {name:"Source Description",index:'description',type:'textarea'},
  {name:"Source Labels",index:'source_labels',type:'select',mode:'tags',options:[]}
]
class SourceList extends Component {
  constructor(props) {
    super(props)



    this.state = {
      filter_query: {
        per_page: 100,
        page: 1
      },
      selected_ids:[],
      adding_to_datatype:false,
      form_data:{},
      all_selected:false
    };

    this.list_sources = RESTExecutor.list().config({
      label: 'list',
      params: {
        ...this.state.filter_query
      }
    }).connect(props.domains.source);

    this.post_sources = RESTExecutor.post().config({
      label: 'list'
    })
      .callbacks((success) => {
        this.setState({
          form_visibility: false,
          edit_id: null,
          form_data: {}
        });
        // this.props.history.push(`/settings/datatype/${this.datatype_id}/pipelines/${success.result.id}`)
        this.list_sources.execute()
      })
      .connect(props.domains.source);

    this.patch_source = RESTExecutor.patch().config({
      label: 'detail',
    })
      .callbacks((success) => {
        this.setState({
          form_visibility: false,
          edit_id: null,
          form_data: {}
        });
        this.list_sources.execute()
      })
      .connect(props.domains.source);

    this.delete_source=RESTExecutor.delete().config({
      label: 'detail',
    })
      .callbacks((success) => {
        message.success("Source deleted.")
        this.list_sources.execute()
      },(error)=>{
        showErrorInNotification(error)
      })
      .connect(props.domains.source);


      this.export_data=RESTExecutor.post().config({
        label:'export'
    }).callbacks((success)=>{
        this.setState({selected_ids:[]})
        // console.log("download url",success)
        window.open(success.result.url, '_blank');

    },(error)=>{
        showErrorInNotification(error)
    }).connect(props.domains.settings);

    this.add_to_datatype=RESTExecutor.post().config({
      label:'add_to_datatype'
    }).callbacks((success)=>{
      message.success("Sources Added to Selected Datatype");
      this.setState({selected_ids:[],adding_to_datatype:false})
    },(error)=>{
      showErrorInNotification(error)
    }).connect(props.domains.settings);



    // this.list_sources.execute();
    this.delay_search=new NetworkDelaySearch();

  };


  handlePostPatch = (data) => {
    if (this.state.edit_id) {
      this.patch_source.forId(this.state.edit_id).execute(data);
    } else {
      this.post_sources.execute(data);
    }
  }

  stateUpdater = ({
    stateKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  render() {
    const {filter_query,selected_ids} = this.state;
    let list_sources_resp=this.list_sources.response();
    let post_source_resp=this.post_sources.response();
    let patch_source_resp=this.patch_source.response();
    let export_data_resp=this.export_data.response();
    let add_to_datatype_resp=this.add_to_datatype.response();

    let rowsData=(list_sources_resp.result&&list_sources_resp.result.rows)||[];
    let rowsMeta=list_sources_resp.meta||{};

    return (
      <div>
        <BasicHeader no_back title="Sources"
                    menu_items={setting_quick_menu}
                    right={[
                        <TransparentButton
                            label="Add New"
                            className='cta-primary'
                            hint="Add New Source"
                            onClick={() => {
                              this.setState({form_data:{},edit_id:null,form_visibility:true})
                            }}

                        />,
                        <TransparentButton
                            label="Unlabelled Source"
                            hint="View unlabelled Source"
                            onClick={() => {
                              this.need_refresh=false;
                              this.setState({unlabelled_drawer:true})                            
                            }}
                        />,
                        <TransparentButton
                            label="Export"
                            hint="Export Selected Source"
                            disabled={selected_ids.length == 0}
                            onClick={() => {
                              this.export_data.execute({
                                sources:selected_ids
                              });
                            }}

                        />,
                        <TransparentButton
                        label="Add To"
                        hint="Add Selected Source To Datatype"
                        disabled={selected_ids.length == 0}
                        onClick={() => {
                          this.setState({adding_to_datatype:true})
                        }}

                    />
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
<Input.Search
                        placeholder="Search For"
                        allowClear
                        style={{
                        }}
                        autoFocus
                        value={filter_query.query}
                        onChange={(e) => {
                        this.stateUpdater({
                          stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                          callback:()=>{
                           
                            this.delay_search.onSearch(()=>{
                              this.props.history.push({
                                search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                              })
                            })
                            
                          }
                        })
                    }}/> 
                    </div>
                    </div>
        <ErrorWrapper
        error={list_sources_resp}
        onReload={()=>{
            this.list_sources.execute()
        }}
        >
        <div
            className='default-card'
            style={{
            padding: 0
        }}>
        
            <Table
                className='main-table' 
                loading={list_sources_resp.fetching||export_data_resp.fetching} 
                size='small' 
                scroll={{x:true}}
                rowSelection={{
                  onChange:(selected_ids)=>{
                    if(selected_ids.length!=rowsMeta.data_count){
                      this.setState({all_selected:false})
                  }
                  this.setState({selected_ids})},
                  selectedRowKeys:selected_ids
                }}
                pagination={{
                  simple: false,
                  position:'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                pageSize: (rowsMeta && rowsMeta.requested_count),
                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
            }} 
            rowKey={(record) => record.id} columns={source_cols({
                onEditPressed:(data)=>{
                  this.setState({
                    edit_id:data.id,
                    form_data:JSON.parse(JSON.stringify(data)),
                    form_visibility:true
                  })
                },
                onDeletePressed:(data)=>{
                  this.delete_source.forId(data.id).execute()
                }
              })} dataSource={rowsData}/>

                 
        </div>
        </ErrorWrapper>

        <PopUpForm
          title={"Select Datatype"}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={[
            { index: 'data_type_id', name: "Datatype", type: 'networkselect', url:`/data-types`},
          ]}
          open={this.state.adding_to_datatype}
          networkState={add_to_datatype_resp}
          onClose={() => this.setState({ adding_to_datatype: false })}
          onSubmit={(data) => {
           
            this.add_to_datatype.execute({
              ...data,sources:selected_ids
            });
          }} />
                    <PopUpForm
                    title={"Source"}
                    forCreate={this.state.edit_id
                    ? false
                    : true}
                    initialData={this.state.form_data}
                    fields={source_schema}
                    open={this.state.form_visibility}
                    networkState={this.state.edit_id
                    ? patch_source_resp
                    : post_source_resp}
                    onClose={() => this.setState({form_visibility: false})}
                    onSubmit={(data) => {
                    console.log("DATA", data);
                    this.handlePostPatch(data);
                }}/>


        <Drawer
                    title="Unlabelled Sources"
                    placement="right"
                    closable={false}
                    width='50%'
                    destroyOnClose
                    onClose={() => {
                      if(this.need_refresh){
                        this.list_sources.execute();
                        this.need_refresh=false
                      }
                        this.setState({
                            unlabelled_drawer: false,
                        })
                    }}
                    visible={this.state.unlabelled_drawer}
                >
                  <UnlabelledSources 
                  onNeedRefresh={()=>{
                    this.need_refresh=true;
                  }}
                  />

                </Drawer>
        </div>
    );
  }

  componentDidMount(){
    overrideHeaderTitle("Sources");
    overrideHeaderBack(null);
    let new_filter_query={};
        if(this.props.location&&this.props.location.search){
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query=parsed;
        }
        this.setState({
        filter_query:{
            per_page:100,
            page:1,
            ...new_filter_query
        }
        },()=>{
        this.list_sources.config({
            params: {
            ...this.state.filter_query
            }
        }).execute()
        })
    
  }
  componentWillReceiveProps (nextProps) {
    
    let new_filter_query={};
    if((this.props.location.search!==nextProps.location.search)){
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query=parsed;
      this.setState({
        filter_query:{
          per_page:100,
          page:1,
          ...new_filter_query
        }
      },()=>{
        this.list_sources.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    }else{
    //   this.list_logs.execute()
    }

    
  }

}

export default withDomains(SourceList, "source","settings");
